import { render, staticRenderFns } from "./grossing-touch-sample-navigation-card.vue?vue&type=template&id=0ffb139c&scoped=true&"
import script from "./grossing-touch-sample-navigation-card.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-sample-navigation-card.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-sample-navigation-card.scss?vue&type=style&index=0&id=0ffb139c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb139c",
  null
  
)

export default component.exports